import React from "react";

const NotFound = () => (
  <div>
    <h2>not found.</h2>
    <p>
      Not Found!?!?! Shit. SHIT. QuiCK GET THE SUIT ON, WE'VE GOT TO GO DOWN
      THERE AND FIND OUT WHATS TEARING UP THE DATA CONNECTIONS! FOR ALL WE KNOW,
      THAT THING COULD BE BACK. BETTER SAFE THAN SORRY, GET YOUR GEAR AND MEET
      ME IN 5. I'LL DO A PRELIMINARY SCA...
    </p>
    <h3>connection lost.</h3>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/views/NotFound.js